// ---------- Validators ----------

const isStrongPassword = (value) => {
  if (!value) return false;
  if (value.length < 12) return false;
  // Reject all-numeric passwords (matches Django's NumericPasswordValidator)
  if (/^\d+$/.test(value)) return false;
  return true;
};

const DOB_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;

// Is the value a real calendar date in MM/DD/YYYY format? (Says nothing about
// age — kept separate so the UI can tell "bad format" apart from "too young".)
const isValidDateString = (value) => {
  const m = DOB_PATTERN.exec(value);
  if (!m) return false;
  const mm = +m[1];
  const dd = +m[2];
  const yy = +m[3];

  // Validate month
  if (mm < 1 || mm > 12) return false;

  // Validate day against the number of days in the entered (1-indexed) month.
  // new Date(yy, mm, 0) is day 0 of the following month = last day of month mm.
  const daysInMonth = new Date(yy, mm, 0).getDate();
  if (dd < 1 || dd > daysInMonth) return false;

  return true;
};

// Is the (already format-valid) date at least 18 years ago?
const isAdultDob = (value) => {
  const m = DOB_PATTERN.exec(value);
  if (!m) return false;

  const dob = new Date(+m[3], +m[1] - 1, +m[2]); // mm-1: JS months are 0-indexed
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dayDiff = today.getDate() - dob.getDate();

  // Adjust age if the birthday hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age -= 1;
  }

  return age >= 18;
};

const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const isValidPhoneNumber = (value) => {
  const digits = (value || '').replace(/[^\d]/g, '');
  return digits.length >= 6 && digits.length <= 15;
};

const isValidUsername = (value) => /^[A-Za-z0-9._-]{3,20}$/.test(value);

const isValidUrl = (value) => {
  try {
    const url = new URL(value);
    return url.isValidUrl();
  } catch (err) {
    return false;
  }
};

const isValidZip = (value) => {
  const zipPattern = /^[0-9]{4,10}$/;
  return zipPattern.test(value);
};

export {
  isStrongPassword,
  isValidDateString,
  isAdultDob,
  isValidEmail,
  isValidPhoneNumber,
  isValidUrl,
  isValidUsername,
  isValidZip,
};
